<ng-container *ngIf="availableLanguages$ | async as _availableLanguages">
  <div id="langSelect" *ngIf="_availableLanguages.length > 1">
    <p-select
      panelStyleClass="ush-panel-overlay"
      appendTo="body"
      #dropdown
      [(ngModel)]="selectedLanguage"
      [options]="_availableLanguages"
      optionLabel="name"
      (onChange)="updateLanguage($event)"
      class="fix"
    >
    </p-select>
  </div>
</ng-container>
